var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMarkerImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13808_31294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9033 81.5375C48.2564 81.9992 47.4814 82.2474 46.6866 82.2474C45.8918 82.2474 45.1169 81.9992 44.47 81.5375C25.3552 67.9129 5.06871 39.8879 25.5768 19.6371C31.205 14.0959 38.7884 10.9931 46.6866 11C54.6033 11 62.1993 14.1073 67.7964 19.6331C88.3046 39.884 68.0181 67.905 48.9033 81.5375Z",
    fill: "#FFB940",
    stroke: "#FFB940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13808_31294)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 16.043,
    width: 46.8493,
    height: 46.8493,
    rx: 23.4247,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 16.543,
    width: 45.8493,
    height: 45.8493,
    rx: 22.9247,
    stroke: "#FFB940"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13808_31294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8922 31.5012L35.5 31.9304L37.3265 29.4457L47.8922 29.1973V31.5012Z",
    fill: "#E75527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2227 32.0657L37.2572 29.3326H37.3266L48.031 29.0615V29.197V31.6365L35.2458 32.0657H35.2227ZM37.3959 29.581L35.7775 31.772L47.7536 31.3655V29.31L37.3959 29.5585V29.581Z",
    fill: "#DD4414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.852 41.3271H50.9219V45.5059H58.852V41.3271Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9207 45.5739H50.875V41.2822H58.9207V45.5739ZM50.9906 45.4609H58.782V41.4178H50.9906V45.4609Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5473 41.0332H35.6172V45.2119H43.5473V41.0332Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5926 45.2799H35.5469V40.9883H43.5926V45.2799ZM35.6625 45.167H43.4538V41.1238H35.6856V45.167H35.6625Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7485 46.3184C57.438 46.3184 57.9969 45.7723 57.9969 45.0986C57.9969 44.425 57.438 43.8789 56.7485 43.8789C56.059 43.8789 55.5 44.425 55.5 45.0986C55.5 45.7723 56.059 46.3184 56.7485 46.3184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7482 46.3411C56.0546 46.3411 55.4766 45.7764 55.4766 45.0988C55.4766 44.4211 56.0546 43.8564 56.7482 43.8564C57.4417 43.8564 58.0197 44.4211 58.0197 45.0988C58.0197 45.7764 57.4417 46.3411 56.7482 46.3411ZM56.7482 43.9016C56.0777 43.9016 55.5228 44.4437 55.5228 45.0988C55.5228 45.7538 56.0777 46.2959 56.7482 46.2959C57.4186 46.2959 57.9735 45.7538 57.9735 45.0988C57.9735 44.4437 57.4186 43.9016 56.7482 43.9016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7931 45.3253C56.9463 45.3253 57.0705 45.204 57.0705 45.0543C57.0705 44.9046 56.9463 44.7832 56.7931 44.7832C56.6398 44.7832 56.5156 44.9046 56.5156 45.0543C56.5156 45.204 56.6398 45.3253 56.7931 45.3253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7018 42.2305C55.0835 42.2305 53.7656 43.518 53.7656 45.1217C53.7656 46.7254 55.0835 48.0129 56.7018 48.0129C58.3202 48.0129 59.638 46.7254 59.638 45.1217C59.638 43.518 58.3202 42.2305 56.7018 42.2305ZM56.7018 47.0416C55.5921 47.0416 54.7135 46.1607 54.7135 45.0765C54.7135 43.9923 55.6152 43.1114 56.7018 43.1114C57.7885 43.1114 58.6901 43.9923 58.6901 45.0765C58.6901 46.1607 57.7885 47.0416 56.7018 47.0416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7015 48.0356C55.06 48.0356 53.7422 46.7255 53.7422 45.1218C53.7422 43.5181 55.0831 42.208 56.7015 42.208C58.3199 42.208 59.6609 43.5181 59.6609 45.1218C59.6609 46.7255 58.3199 48.0356 56.7015 48.0356ZM56.7015 42.2532C55.1063 42.2532 53.8115 43.5407 53.8115 45.0992C53.8115 46.6578 55.1063 47.9453 56.7015 47.9453C58.2968 47.9453 59.5915 46.6578 59.5915 45.0992C59.5915 43.5407 58.2968 42.2532 56.7015 42.2532ZM56.7015 47.0644C55.5918 47.0644 54.667 46.1609 54.667 45.0541C54.667 43.9473 55.5687 43.0438 56.7015 43.0438C57.8344 43.0438 58.7361 43.9473 58.7361 45.0541C58.7361 46.1609 57.8344 47.0644 56.7015 47.0644ZM56.7015 43.1341C55.6149 43.1341 54.7363 43.9924 54.7363 45.0766C54.7363 46.1609 55.6149 47.0192 56.7015 47.0192C57.7882 47.0192 58.6667 46.1609 58.6667 45.0766C58.6667 43.9924 57.7882 43.1341 56.7015 43.1341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7758 46.3184C40.4653 46.3184 41.0243 45.7723 41.0243 45.0986C41.0243 44.425 40.4653 43.8789 39.7758 43.8789C39.0863 43.8789 38.5273 44.425 38.5273 45.0986C38.5273 45.7723 39.0863 46.3184 39.7758 46.3184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7755 46.3411C39.0819 46.3411 38.5039 45.7764 38.5039 45.0988C38.5039 44.4211 39.0819 43.8564 39.7755 43.8564C40.4691 43.8564 41.0471 44.4211 41.0471 45.0988C41.0471 45.7764 40.4691 46.3411 39.7755 46.3411ZM39.7755 43.9016C39.105 43.9016 38.5501 44.4437 38.5501 45.0988C38.5501 45.7538 39.105 46.2959 39.7755 46.2959C40.446 46.2959 41.0008 45.7538 41.0008 45.0988C41.0008 44.4437 40.446 43.9016 39.7755 43.9016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6713 42.9305H59.7986L58.5039 41.7334H61.6713V42.9305Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3476 43.0885H43.9609V41.7559H55.2665L53.3476 43.0885Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8243 45.3253C39.9775 45.3253 40.1017 45.204 40.1017 45.0543C40.1017 44.9046 39.9775 44.7832 39.8243 44.7832C39.6711 44.7832 39.5469 44.9046 39.5469 45.0543C39.5469 45.204 39.6711 45.3253 39.8243 45.3253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7331 42.2305C38.1147 42.2305 36.7969 43.518 36.7969 45.1217C36.7969 46.7254 38.1147 48.0129 39.7331 48.0129C41.3515 48.0129 42.6693 46.7254 42.6693 45.1217C42.6693 43.518 41.3515 42.2305 39.7331 42.2305ZM39.7331 47.0416C38.6233 47.0416 37.7448 46.1607 37.7448 45.0765C37.7448 43.9923 38.6465 43.1114 39.7331 43.1114C40.8197 43.1114 41.7214 43.9923 41.7214 45.0765C41.7214 46.1607 40.8197 47.0416 39.7331 47.0416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7328 48.0356C38.0913 48.0356 36.7734 46.7255 36.7734 45.1218C36.7734 43.5181 38.1144 42.208 39.7328 42.208C41.3512 42.208 42.6921 43.5181 42.6921 45.1218C42.6921 46.7255 41.3512 48.0356 39.7328 48.0356ZM39.7328 42.2532C38.1375 42.2532 36.8428 43.5407 36.8428 45.0992C36.8428 46.6578 38.1375 47.9453 39.7328 47.9453C41.328 47.9453 42.6227 46.6578 42.6227 45.0992C42.6227 43.5407 41.328 42.2532 39.7328 42.2532ZM39.7328 47.0644C38.623 47.0644 37.6982 46.1609 37.6982 45.0541C37.6982 43.9473 38.5999 43.0438 39.7328 43.0438C40.8656 43.0438 41.7673 43.9473 41.7673 45.0541C41.7673 46.1609 40.8656 47.0644 39.7328 47.0644ZM39.7328 43.1341C38.6461 43.1341 37.7676 43.9924 37.7676 45.0766C37.7676 46.1609 38.6461 47.0192 39.7328 47.0192C40.8194 47.0192 41.698 46.1609 41.698 45.0766C41.698 43.9924 40.8194 43.1341 39.7328 43.1341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0781 44.0378C36.0781 44.0378 36.2631 42.163 37.8583 41.6209C39.4536 41.0788 38.0433 41.7113 38.0433 41.7113",
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1234 44.0374H36.0078C36.0078 44.0374 36.2159 42.0949 37.8343 41.5754C38.6203 41.3043 38.6435 41.3269 38.6666 41.3947C38.6666 41.4398 38.7128 41.485 38.0655 41.7561L38.0192 41.6431C38.0192 41.6431 38.158 41.5754 38.2042 41.5528C38.1117 41.5754 37.9961 41.6205 37.8574 41.6657C36.3315 42.1852 36.1234 44.0148 36.1234 44.0148V44.0374Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5208 45.3027H47.9598V31.976C47.9598 31.976 47.9598 31.3887 47.4742 31.3887L35.9606 31.7501C35.9606 31.7501 35.4751 31.7501 35.1283 32.3374C34.7584 32.9246 32.377 36.0869 31.5447 38.3005C31.5447 38.3005 31.1748 38.7748 31.4291 43.3376L31.5447 44.9639C31.5447 44.9639 31.4291 45.3253 32.1458 45.3253H36.3305C36.3305 45.3253 36.2843 44.738 36.3767 44.0829C36.4461 43.6764 36.5386 43.2246 36.7467 42.8858C36.816 42.7729 36.9085 42.6599 36.9085 42.6599C37.2784 42.1856 37.6946 41.9145 37.9951 41.7564C39.1049 41.7564 40.2146 41.7564 41.3244 41.7338C41.3706 41.8468 43.2202 43.0213 43.1508 44.1959L43.4745 45.3704L43.5208 45.3027Z",
    fill: "#E75527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4289 45.438L43.059 44.1505C43.1052 43.247 41.9955 42.3661 41.5099 41.9821C41.4175 41.8917 41.3481 41.8465 41.3019 41.824C40.2152 41.824 39.1286 41.824 38.0651 41.8465C37.6721 42.0724 37.3253 42.3661 37.0478 42.7049C37.0478 42.7049 36.9553 42.8178 36.886 42.9308C36.7241 43.2018 36.6085 43.6084 36.5392 44.0827C36.4467 44.7152 36.4929 45.3025 36.4929 45.3025V45.438H32.1695C31.8228 45.438 31.6147 45.3702 31.4991 45.2121C31.4297 45.0992 31.4297 44.9862 31.4297 44.9411L31.3141 43.3148C31.106 39.2038 31.3604 38.368 31.4528 38.2325C32.1233 36.4707 33.7417 34.1667 34.5971 32.9244C34.8052 32.6308 34.967 32.3823 35.0595 32.2694C35.4526 31.6369 35.9843 31.6143 36.0074 31.6143L47.5211 31.2529C48.0066 31.2529 48.1453 31.7273 48.1453 31.9757V45.438H43.452H43.4289ZM43.3364 44.1279L43.637 45.1895H47.8448V31.9983C47.8448 31.9531 47.8448 31.5466 47.498 31.5466L35.9843 31.908C35.9843 31.908 35.5682 31.908 35.2676 32.4275C35.1982 32.5404 35.0364 32.7889 34.8052 33.1051C33.996 34.2571 32.3545 36.6288 31.684 38.368C31.684 38.368 31.3604 39.0231 31.5916 43.3373L31.7072 45.0088C31.7072 45.0088 31.7072 45.0766 31.7072 45.0992C31.7072 45.1218 31.8228 45.2121 32.1695 45.2121H36.2155C36.2155 44.9862 36.2155 44.5571 36.2849 44.0827C36.3542 43.5632 36.4929 43.134 36.6779 42.8404C36.7473 42.7049 36.8629 42.5919 36.8629 42.5919C37.1634 42.208 37.5333 41.8917 37.9957 41.6433H38.0189H38.042C39.1517 41.6433 40.2615 41.6433 41.3712 41.6207H41.4637L41.5099 41.711C41.5099 41.711 41.6024 41.7788 41.6949 41.8465C42.2035 42.2531 43.3826 43.2018 43.3595 44.1957L43.3364 44.1279Z",
    fill: "#DD4414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5586 36.606C33.5586 36.606 35.3157 33.4889 35.6625 33.0145C36.0093 32.5402 36.4948 32.5402 36.4948 32.5402C36.4948 32.5402 40.8182 32.3369 41.165 32.3369C41.5118 32.3369 41.5349 32.6531 41.5349 32.6531C41.5349 32.6531 41.3962 35.3411 41.3962 35.454C41.3962 35.567 41.2806 36.0865 41.2806 36.0865L33.5586 36.5834V36.606Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4645 36.674L33.5108 36.5837C33.5801 36.4481 35.2679 33.4666 35.6147 32.9922C35.9846 32.5179 36.4701 32.4953 36.4932 32.4953C36.6782 32.4953 40.8166 32.292 41.1634 32.292C41.4871 32.292 41.5796 32.5405 41.5796 32.676C41.5796 32.6986 41.4409 35.3639 41.4409 35.4769C41.4409 35.5898 41.3253 36.0641 41.3253 36.1319V36.1771H41.279L33.4414 36.674H33.4645ZM41.1865 32.4049C40.8397 32.4049 36.5626 32.6082 36.5163 32.6082C36.5163 32.6082 36.0539 32.6082 35.7303 33.06C35.4066 33.4666 33.95 36.0641 33.6726 36.5611L41.2559 36.0867C41.3021 35.9286 41.3715 35.5898 41.3715 35.4994C41.3715 35.3865 41.4871 32.8115 41.5102 32.6986C41.5102 32.676 41.5102 32.4275 41.2097 32.4275L41.1865 32.4049Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1 41.7334V46.6123H43.1755C43.2448 46.1606 43.3604 45.0764 42.8287 43.8341C42.3432 42.6821 41.534 42.0045 41.1641 41.7334",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4062 44.986L32.909 44.873L32.9784 46.6349H32.0074C32.0074 46.6349 31.6374 46.6349 31.5218 46.4542C31.4062 46.2735 31.4062 44.986 31.4062 44.986Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8398 44.3308L36.5621 44.1953C36.5621 44.1953 36.4696 46.1604 36.6777 46.6574H32.8398V44.3534V44.3308Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41.5332 41.0109C41.5332 41.0109 41.5101 41.0109 41.5101 40.9883L41.3945 35.6124C41.3945 35.6124 41.3945 35.5898 41.4177 35.5898C41.4177 35.5898 41.4408 35.5898 41.4408 35.6124L41.5564 40.9883C41.5564 40.9883 41.5564 41.0109 41.5332 41.0109Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.8178 44.8733L32.7022 42.5693L32.6328 38.2325L33.4882 36.6514C33.4882 36.6514 33.4882 36.6514 33.5345 36.6514C33.5345 36.6514 33.5345 36.674 33.5345 36.6965L32.7022 38.2551L32.7715 42.5919L32.864 44.8281L35.7077 44.7603L35.8465 42.8856C36.1008 42.5242 36.3782 42.1628 36.7019 41.8691C37.0487 41.5303 37.4648 41.2367 37.9041 40.9882H41.4877C41.4877 40.9882 41.5108 40.9882 41.5108 41.0108C41.5108 41.0334 41.5108 41.0334 41.4877 41.0334H37.9041C37.4648 41.2818 37.0718 41.5755 36.725 41.9143C36.4013 42.2079 36.1239 42.5468 35.8696 42.9082L35.7309 44.8281H35.7077L32.7715 44.8959L32.8178 44.8733Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0492 37.2158H40.1937C40.1299 37.2158 40.0781 37.2664 40.0781 37.3288V37.4869C40.0781 37.5492 40.1299 37.5998 40.1937 37.5998H41.0492C41.113 37.5998 41.1648 37.5492 41.1648 37.4869V37.3288C41.1648 37.2664 41.113 37.2158 41.0492 37.2158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4531 41.2814L32.6322 41.0781L32.3548 41.8461V43.2691L31.5456 43.4498L31.4531 41.2814Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5466 41.8916L32.2633 41.7561L32.5176 41.1914L31.5234 41.3947L31.5466 41.8916Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5842 44.3914L31.7323 44.4673C31.6687 44.4729 31.6219 44.5279 31.6277 44.59L31.6424 44.7475C31.6482 44.8096 31.7044 44.8554 31.768 44.8497L32.6199 44.7738C32.6835 44.7681 32.7303 44.7132 32.7245 44.6511L32.7098 44.4936C32.704 44.4315 32.6478 44.3857 32.5842 44.3914Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6237 46.5453H60.4677L59.8203 42.999H61.6237V46.5453Z",
    fill: "#E75527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7641 46.6806H60.3538L59.6602 42.8633H61.7641V46.6806ZM60.5849 46.4095H61.5097V43.1117H60.007L60.6081 46.4095H60.5849Z",
    fill: "#DD4414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0472 46.5453H44.2617V43.1797H53.4403L53.0472 46.5453Z",
    fill: "#E75527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1645 46.6806H44.1016V43.0439H53.5807L53.1645 46.6806ZM44.379 46.4095H52.9102L53.257 43.315H44.3559V46.4095H44.379Z",
    fill: "#DD4414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4297 40.6951L32.6782 40.424L32.655 39.5205L31.4297 39.7916",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4294 40.6951L31.4062 40.6725L32.6778 40.424L32.6547 39.5205L31.4294 39.7916L32.6547 39.5205L32.6778 40.424L31.4294 40.6951Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5634 44.1279L36.679 43.2921L38.0431 41.6658L48.1002 41.6432V40.8301H37.65L35.8698 42.75L35.7773 44.1731L36.5634 44.1279Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.863 41.0558C32.863 41.0558 32.8398 41.0558 32.8398 41.0332C32.8398 41.0332 32.8398 41.0107 32.863 41.0107L37.4176 40.8525C37.4176 40.8525 37.4407 40.8525 37.4407 40.8751C37.4407 40.8751 37.4407 40.8977 37.4176 40.8977L32.863 41.0558Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9344 36.0191L42.4606 36.1094L42.4375 32.3147L44.8882 32.2695L44.9344 36.0191Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4141 36.1549V32.2698H42.4603L44.9572 32.2246V32.2698L45.0035 36.0645H44.9572L42.4372 36.1549H42.4141ZM42.5065 32.3601V36.0419L44.8648 35.9516L44.8185 32.315L42.4834 32.3601H42.5065Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1992 36.5608L38.7134 32.4047L39.8463 32.3369L37.1182 36.4253L35.5691 36.5382L35.1992 36.5608Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M37.7414 41.7111L31.5222 43.2244L32.7938 42.6597L31.4297 43.4955L31.5684 45.6639L31.6146 46.3641L32.7244 46.5222L36.4467 45.935C36.4467 45.935 36.516 41.6659 38.4812 41.5078C40.4464 41.3497 41.6486 41.5078 41.6486 41.5078L43.7294 41.44",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M44.1953 31.4111H45.3282C45.5363 31.4111 45.675 31.5692 45.675 31.7499V40.9657H44.1953V31.4111Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M47.2227 31.5459H47.6157C47.7313 31.5459 47.8469 31.6362 47.8469 31.7718V40.6939H47.2227V31.5459Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M53.003 45.1443H44.125V43.0889L53.396 43.1115L53.003 45.1443Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M61.5084 45.2573L60.3061 45.2799L59.8438 43.0889H61.5777L61.5084 45.2573Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7446 30.2133L47.0156 29.9648L46.9463 29.626L37.7446 29.8519L37.3516 30.281",
    fill: "#E5E9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3187 45.4824C42.4343 46.1826 42.0181 46.8603 41.3477 47.0861V47.041L42.2493 45.5276V45.4824H42.3187Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2344 44.2855C37.2344 43.5626 37.743 42.9754 38.4366 42.8398V42.885L37.3037 44.2629H37.2806V44.308L37.2344 44.2855Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3577 45.4385C59.4733 46.1387 59.0572 46.8163 58.3867 47.0422V46.997L59.2884 45.4837V45.4385H59.3577Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2734 44.263C54.2734 43.5402 54.7821 42.9529 55.4757 42.8174V42.8626L54.3428 44.2404H54.3197V44.2856L54.2734 44.263Z",
    fill: "#CCCCCC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13808_31294",
    x: 3,
    y: -3.95703,
    width: 88.8477,
    height: 88.8496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.72549 0 0 0 0 0.25098 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13808_31294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13808_31294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13808_31294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13808_31294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25.1351,
    fill: "white",
    transform: "translate(31.4258 22.9004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerImage);
export default __webpack_public_path__ + "static/media/location-marker-image.f14c2fd24c20d142ad42ccd855024625.svg";
export { ForwardRef as ReactComponent };